export default __webpack_public_path__ + "static/media/money-active.c9438923.svg";